import { CSS } from '../../const';
import { SelectClickable } from '../selection';
import { NavigationItemOptions } from '../../interfaces/options';

export class NavigationItem extends SelectClickable {
	private css: KnockoutComputed<string>;
	private icon: string;
	private label: string;
	private customCss: string;
    private visible: KnockoutObservable<boolean>;
    private disabled: KnockoutObservable<boolean>;

	constructor(options: NavigationItemOptions) {
		super(options);
		this.label = options.label;
		this.icon = options.icon;
        this.customCss = options.css;

		this.visible = ko.isObservable(options.visible)
			? options.visible
            : ko.observable<boolean>(true);

        this.disabled = ko.isObservable(options.disabled)
            ? options.disabled
            : ko.observable<boolean>(false);

        this.css = ko.pureComputed(() => {

			var _css: string = this.icon.concat(
				' ',
				this.id,
				' ',
				this.isSelected() ? CSS.Selected : '',
				' ',
				this.customCss || ' ',
                ' ',
                this.disabled() ? 'disabled' : ''
            );

			return _css;
		});
	}
}
